import React from "react";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { cn } from "@/Components/ui/utils";
import { Card, Nav, NavItem, NavLink, Row, Col, CardBody, Container } from "@/Components/Common/Tailwind";
import {
  MYPAGE_SUMMARY_QUERY_KEY,
  mypageService,
} from "@/api/services/mypage.service";
import ReservationGift from "./ReservationGift";
import UserVoucherGift from "./VoucherGift";
import TicketGift from "./TicketGift";
import CouponGift from "./CouponGift";
import Navbar from "../../../Components/Common/navbar";
import MobileViewContainer from "../../../Components/MobileViewContainer";

const GiftTabLabel = ({ label, count = 0 }) => (
  <span className="relative inline-flex items-center">
    {label}
    {count > 0 ? (
      <>
        <span
          aria-hidden="true"
          className="absolute -right-3 -top-2 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[9px] font-bold leading-none text-white"
        >
          {count > 99 ? "99+" : count}
        </span>
        <span className="sr-only">미수령 선물 {count}개</span>
      </>
    ) : null}
  </span>
);

const GiftTabView = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: summary } = useQuery({
    queryKey: MYPAGE_SUMMARY_QUERY_KEY,
    queryFn: async () => {
      const response = await mypageService.getSummary();
      return response.data;
    },
    staleTime: 30000,
  });

  // Custom Tabs Bordered
  const [customActiveTab, setcustomActiveTab] = React.useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const refreshGiftCounts = React.useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: MYPAGE_SUMMARY_QUERY_KEY,
      }),
    [queryClient],
  );

  return (
    <MobileViewContainer>
      <Navbar />
      <Container fluid className="min-h-screen bg-white pb-24">
        <Row className="justify-center pt-4">
          <Col xs={12} sm={12} md={12} xl={12} xxl={12}>
            <Card className="w-full overflow-hidden bg-white bg-opacity-50">
              <CardBody style={{ padding: 0 }}>
                <Nav tabs justified className="nav nav-tabs nav-tabs-custom nav-danger nav-justified mb-3 bg-body bg-opacity-10">
                  <NavItem className="min-w-0">
                    <NavLink
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      className={cn({
                        "active w-full whitespace-nowrap px-2 text-center": customActiveTab === "1",
                        "w-full whitespace-nowrap px-2 text-center": customActiveTab !== "1",
                      })}
                      onClick={() => {
                        toggleCustom("1");
                      }}
                    >
                      <GiftTabLabel
                        label="예약"
                        count={summary?.reservation_gift_count}
                      />
                    </NavLink>
                  </NavItem>
                  <NavItem className="min-w-0">
                    <NavLink
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      className={cn({
                        "active w-full whitespace-nowrap px-2 text-center": customActiveTab === "3",
                        "w-full whitespace-nowrap px-2 text-center": customActiveTab !== "3",
                      })}
                      onClick={() => {
                        toggleCustom("3");
                      }}
                    >
                      <GiftTabLabel
                        label="티켓"
                        count={summary?.ticket_gift_count}
                      />
                    </NavLink>
                  </NavItem>
                  <NavItem className="min-w-0">
                    <NavLink
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      className={cn({
                        "active w-full whitespace-nowrap px-2 text-center": customActiveTab === "2",
                        "w-full whitespace-nowrap px-2 text-center": customActiveTab !== "2",
                      })}
                      onClick={() => {
                        toggleCustom("2");
                      }}
                    >
                      <GiftTabLabel
                        label="교환권"
                        count={summary?.voucher_gift_count}
                      />
                    </NavLink>
                  </NavItem>
                  <NavItem className="min-w-0">
                    <NavLink
                      style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      className={cn({
                        "active w-full whitespace-nowrap px-2 text-center": customActiveTab === "4",
                        "w-full whitespace-nowrap px-2 text-center": customActiveTab !== "4",
                      })}
                      onClick={() => {
                        toggleCustom("4");
                      }}
                    >
                      <GiftTabLabel
                        label="쿠폰"
                        count={summary?.coupon_gift_count}
                      />
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
              <div>
                {customActiveTab === "1" ? (
                  <ReservationGift
                    navigate={navigate}
                    onGiftReceived={refreshGiftCounts}
                  />
                ) : null}
                {customActiveTab === "2" ? (
                  <UserVoucherGift
                    navigate={navigate}
                    onGiftReceived={refreshGiftCounts}
                  />
                ) : null}
                {customActiveTab === "3" ? (
                  <TicketGift
                    navigate={navigate}
                    onGiftReceived={refreshGiftCounts}
                  />
                ) : null}
                {customActiveTab === "4" ? (
                  <CouponGift
                    navigate={navigate}
                    onGiftReceived={refreshGiftCounts}
                  />
                ) : null}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </MobileViewContainer>
  );
};
export default GiftTabView;
